// Replaces the heading of the signup view on /login#signup.
//
// frappe/www/login.html builds it as _('Create a {0} Account').format(app_name), and this
// app sets app_name to the login heading's text (website_overrides.update_website_context),
// so it read "Create a your e-shop. ... Account". The template is Frappe's own and is not
// shadowed, so the heading is rewritten from here, in the login heading's markup: the title,
// then the subtitle on its own line.
//
// Both strings are translated server-side and handed over in a global written into
// body_include (website_overrides.set_login_signup_heading), for the reason given in
// login_eshop_link.js: /login carries no message dictionary, so __() would return English.

const LOGIN_PATH = "/login"
// Marks the heading once rewritten, so running twice leaves it as it is.
const PLACED_FLAG = "ioiSignupHeading"

function set_signup_heading() {
	if (!window.location.pathname.startsWith(LOGIN_PATH)) {
		return
	}

	const heading = window.ioi_partners_login_signup_heading
	if (!heading || !heading.title) {
		// No text from the server: keep Frappe's heading rather than show an empty one.
		return
	}

	// The h4 of logo_section() only. The signup-disabled notice also has a .page-card-head,
	// but inside .login-content and without an h4, so it is not matched.
	const h4 = document.querySelector("section.for-signup > .page-card-head > h4")
	if (!h4 || h4.dataset[PLACED_FLAG]) {
		return
	}
	h4.dataset[PLACED_FLAG] = "1"

	h4.textContent = heading.title
	if (heading.subtitle) {
		h4.appendChild(document.createElement("br"))
		const subtitle = document.createElement("span")
		subtitle.className = "px-2 small text-muted"
		subtitle.textContent = heading.subtitle
		h4.appendChild(subtitle)
	}
}

frappe.ready(set_signup_heading)
